import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, map } from 'rxjs';
import { UrlTree } from '@angular/router';
import { UserService } from '../service/user-service';
import { OpenIdService } from '../service/open-id.service';

export abstract class RoleGuard implements CanActivate {
    public abstract requireRole: string;

    constructor(private openIdService: OpenIdService, private router: Router) {}
    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        return this.openIdService.$userProfile.pipe(
            map(() => {
                return this.openIdService.keycloak.hasRealmRole(
                    this.requireRole
                );
            })
        );
    }
}
